import { Provider, useApollo, type NormalizedCacheObject } from "./CSR";

export { useQuery, type NormalizedCacheObject } from "./CSR";

const ApolloProvider: React.FC<{
  children: React.ReactNode;
  initialState?: NormalizedCacheObject
}> = ({ children, initialState }) => {
  return (
    <Provider client={useApollo(initialState)}>
      {children}
    </Provider>
  );
}
export default ApolloProvider;